import { getLogger, type GqlExecutor } from '@hopdrive/sdk-core'
import { getRoleTypeByName } from '@gql/operations'
import type { RoleType } from '../../types'
import { RoleTypeNotFoundError } from '../../errors/event-errors'

export async function getRoleByName(
  name: string,
  executor?: GqlExecutor
): Promise<RoleType> {
  const result = await getRoleTypeByName({ name }, { executor })

  const roletype = result?.[0]
  if (!roletype) {
    throw new RoleTypeNotFoundError(name)
  }

  getLogger().debug('event.roleTypeLookup', { name, id: roletype.id })

  return {
    id: roletype.id as number,
    name: roletype.name as string,
  }
}
